"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AstroCalculator = exports.Astro = exports.revJulDay = exports.julDay = void 0;
var aspects_1 = require("./aspects");
var astro_utils_1 = require("./astro-utils");
var dayjs_1 = __importDefault(require("./dayjs"));
var defs_1 = require("./defs");
var settings_1 = require("./settings");
var strong_aspects_1 = require("./strong-aspects");
var utils_1 = require("./utils");
function julDay(dt, isGreg) {
    if (isGreg === void 0) { isGreg = true; }
    var m = dayjs_1["default"].utc(dt);
    var year = m.year();
    var month = m.month() + 1;
    if (month < 3)
        year -= 1.0;
    var u1 = month + 1.0;
    if (u1 < 4)
        u1 += 12.0;
    var time = m.hour() + m.minute() / 60.0 + m.second() / 3600.0;
    var jd = Math.floor((year + 4712.0) * 365.25) + Math.floor(30.6 * u1 + 0.000001) + m.date() + time / 24.0 - 63.5;
    if (isGreg) {
        var u2 = Math.floor(Math.abs(year) / 100) - Math.floor(Math.abs(year) / 400);
        if (year < 0.0)
            u2 = -u2;
        jd = jd - u2 + 2;
        if (year < 0.0 && year / 100 === Math.floor(year / 100) && year / 400 !== Math.floor(year / 400))
            jd -= 1.0;
    }
    return jd;
}
exports.julDay = julDay;
function revJulDay(jd, gmt) {
    if (gmt === void 0) { gmt = 0; }
    return (0, dayjs_1["default"])(new Date((jd - 2440587.5) * 86400000)).add(gmt, 'hours').toISOString();
}
exports.revJulDay = revJulDay;
function getHSys(lat, hSys, northLat, northHSys) {
    return lat >= northLat ? northHSys : hSys;
}
var Astro = (function () {
    function Astro(calc, settings) {
        this._calc = calc;
        this.settings = (0, settings_1.deserializeAstroSettings)(settings !== null && settings !== void 0 ? settings : settings_1.dfltSettings);
    }
    Astro.prototype.julDay = function (dt) {
        return julDay(dt, (0, dayjs_1["default"])(dt).year() > 1600);
    };
    Astro.prototype.houses = function (dt, hSys, lat, lon) {
        return __awaiter(this, void 0, void 0, function () {
            var calc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        return [2, calc.houses(this.julDay(dt), hSys, lat, lon)];
                }
            });
        });
    };
    Astro.prototype.object = function (dt, obj) {
        return __awaiter(this, void 0, void 0, function () {
            var calc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        return [2, calc.object(this.julDay(dt), obj)];
                }
            });
        });
    };
    Astro.prototype.objects = function (dt) {
        return __awaiter(this, void 0, void 0, function () {
            var calc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        return [2, calc.objects(this.julDay(dt))];
                }
            });
        });
    };
    Astro.prototype.star = function (dt, name) {
        return __awaiter(this, void 0, void 0, function () {
            var calc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        return [2, calc.star(this.julDay(dt), name)];
                }
            });
        });
    };
    Astro.prototype.birthDaySign = function (dt) {
        return __awaiter(this, void 0, void 0, function () {
            var lon;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.object(dt, defs_1.ObjectType.Sun)];
                    case 1:
                        lon = (_a.sent()).lon;
                        return [2, (0, astro_utils_1.getSign)(lon)];
                }
            });
        });
    };
    Astro.prototype.natal = function (dt, lat, lon, cosmogram, hSys, northLat, northHSys) {
        return __awaiter(this, void 0, void 0, function () {
            var calc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        return [2, calc.natal(this.julDay(dt), lat, lon, cosmogram !== null && cosmogram !== void 0 ? cosmogram : false, getHSys(lat, hSys !== null && hSys !== void 0 ? hSys : this.settings.housesSystem.common, northLat !== null && northLat !== void 0 ? northLat : this.settings.northernLatitude, northHSys !== null && northHSys !== void 0 ? northHSys : this.settings.housesSystem.northern))];
                }
            });
        });
    };
    Astro.prototype.solars = function (sunLon, dt, lat, lon) {
        return __awaiter(this, void 0, void 0, function () {
            var calc, solarDt, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        solarDt = revJulDay(calc.solarJulDay(sunLon, this.julDay(dt)));
                        return [4, this.natal(solarDt, lat, lon)];
                    case 2:
                        result = _a.sent();
                        return [2, __assign(__assign({}, result), { dt: solarDt })];
                }
            });
        });
    };
    Astro.prototype.progressions = function (natDate, dt, lat, lon) {
        return __awaiter(this, void 0, void 0, function () {
            var calc, diff, progJD, _hsys, housesEnd1, housesEnd2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        diff = dayjs_1["default"].utc(dt).diff(natDate, 'years', true);
                        progJD = this.julDay(dayjs_1["default"].utc(natDate).add(diff * 24, 'hours').toISOString());
                        _hsys = getHSys(lat, this.settings.housesSystem.common, this.settings.northernLatitude, this.settings.housesSystem.northern);
                        housesEnd1 = calc.houses(this.julDay(dayjs_1["default"].utc(natDate).add(Math.floor(diff), 'days').toISOString()), _hsys, lat, lon);
                        housesEnd2 = calc.houses(this.julDay(dayjs_1["default"].utc(natDate).add(Math.ceil(diff), 'days').toISOString()), _hsys, lat, lon);
                        return [2, {
                                objects: calc.objects(progJD),
                                houses: housesEnd1.map(function (h, i) { return h + (diff - Math.floor(diff)) * (0, utils_1.circularDistance)(housesEnd1[i], housesEnd2[i], 360); }),
                                dt: revJulDay(progJD)
                            }];
                }
            });
        });
    };
    Astro.prototype.horar = function (dt, lat, lon) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.natal(dt, lat, lon, false, this.settings.housesSystem.horar, this.settings.northernLatitude, this.settings.housesSystem.northern)];
            });
        });
    };
    Astro.prototype.riseObject = function (obj, dt, lon, lat, isNextRise) {
        return __awaiter(this, void 0, void 0, function () {
            var calc, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        result = calc.riseObject(this.julDay(dt), obj, lat, lon, isNextRise);
                        return [2, result !== 0 ? revJulDay(result) : ''];
                }
            });
        });
    };
    Astro.prototype.setObject = function (obj, dt, lon, lat, isNextRise) {
        return __awaiter(this, void 0, void 0, function () {
            var calc, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._calc];
                    case 1:
                        calc = _a.sent();
                        result = calc.setObject(this.julDay(dt), obj, lat, lon);
                        return [2, result !== 0 ? revJulDay(result) : ''];
                }
            });
        });
    };
    Astro.prototype.getOrbise = function (mode, objType, aspType) {
        if (objType >= defs_1.ObjectType.House1) {
            objType = 13;
        }
        else if (objType > defs_1.ObjectType.NorthNode) {
            objType--;
        }
        return this.settings.maps[(0, astro_utils_1.profileMode)(mode)].orbises[aspType][objType];
    };
    Astro.prototype.isPlanet = function (obj) {
        return obj <= defs_1.ObjectType.Pluto;
    };
    Astro.prototype.isCuspid = function (obj) {
        return obj >= defs_1.ObjectType.House1;
    };
    Astro.prototype.getPairOrbise = function (mode, obj1, obj2, aspType) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var has = function (list) {
            var _a;
            var check = function (obj) { var _a; return _this.settings.id === 0 && ['natal', 'synastry'].includes(mode) && list.includes(obj) ? ((_a = _this.getOrbise(mode, obj, aspType)) === null || _a === void 0 ? void 0 : _a.value) || 0 : null; };
            return (_a = check(obj1)) !== null && _a !== void 0 ? _a : check(obj2);
        };
        var oneObjIsCuspid = this.isCuspid(obj1) || this.isCuspid(obj2);
        if (!(0, astro_utils_1.isPrognostics)(mode) && oneObjIsCuspid && (!this.isCuspid(obj2) || !this.isCuspid(obj1))) {
            var cuspid = this.isCuspid(obj1) ? obj1 : obj2;
            return ((_a = this.getOrbise(mode, cuspid, aspType)) === null || _a === void 0 ? void 0 : _a.value) || 0;
        }
        return (_d = (_c = (_b = has([defs_1.ObjectType.NorthNode, defs_1.ObjectType.SouthNode])) !== null && _b !== void 0 ? _b : has([defs_1.ObjectType.Lilith])) !== null && _c !== void 0 ? _c : has([defs_1.ObjectType.Sun, defs_1.ObjectType.Moon])) !== null && _d !== void 0 ? _d : Math.max(((_e = this.getOrbise(mode, obj1, aspType)) === null || _e === void 0 ? void 0 : _e.value) || 0, ((_f = this.getOrbise(mode, obj2, aspType)) === null || _f === void 0 ? void 0 : _f.value) || 0);
    };
    Astro.prototype.natalAspects = function (objects, orbiseCorrector, houses, isRounded, options) {
        return (0, aspects_1.natalAspects)(objects, this.checkAspectOpts('natal', orbiseCorrector, isRounded, options), this.getPairOrbise.bind(this), houses);
    };
    Astro.prototype.synastryAspects = function (objects, objectsExt) {
        return (0, aspects_1.synastryAspects)(objects, objectsExt, this.checkAspectOpts('compatibility'), this.getPairOrbise.bind(this));
    };
    Astro.prototype.prognosticsAspects = function (mode, objects, houses, objectsExt, housesExt, forDoubleMapWithOutNatal) {
        return (0, aspects_1.prognosticsAspects)(mode, objects, houses, objectsExt, housesExt, this.checkAspectOpts(mode), this.getPairOrbise.bind(this), forDoubleMapWithOutNatal);
    };
    Astro.prototype.synastryTransitAspects = function (transitObjects, transitHouses, partnerObjects, partnerHouses, natalObjects, natalHouses, synastryAspects, transitMode) {
        return (0, aspects_1.synastryTransitAspects)(transitObjects, transitHouses, partnerObjects, partnerHouses, natalObjects, natalHouses, synastryAspects, this.checkAspectOpts('transits'), this.getPairOrbise.bind(this), transitMode);
    };
    Astro.prototype.strongAspects = function (natal) {
        var nAspects = this.natalAspects(natal.objects);
        return (0, strong_aspects_1.strongAspects)(natal, nAspects);
    };
    Astro.prototype.checkAspectOpts = function (mode, orbiseCorrector, isRounded, options) {
        var _a, _b;
        var _mode = (0, astro_utils_1.profileMode)(mode);
        var map = this.settings.maps[_mode];
        return __assign({ isRounded: isRounded !== null && isRounded !== void 0 ? isRounded : this.settings.isRounded, orbiseCorrector: orbiseCorrector !== null && orbiseCorrector !== void 0 ? orbiseCorrector : map.orbiseCorrector, ignoreDiffSigns: _mode !== 'natal', overSign: this.settings.overSign, overSign0: this.settings.overSign0, floatingOrbise: ((_a = options === null || options === void 0 ? void 0 : options.floatingOrbise) !== null && _a !== void 0 ? _a : _mode === 'natal') ? this.settings.closureConfig : 0, maxCuspidOrbise: (_b = this.settings.maps.natal.orbises[0][13].value) !== null && _b !== void 0 ? _b : 4 }, options);
    };
    return Astro;
}());
exports.Astro = Astro;
var AstroCalculator = (function () {
    function AstroCalculator() {
    }
    AstroCalculator.prototype.objects = function (jd) {
        var res = [];
        for (var obj = defs_1.ObjectType.Sun; obj < defs_1.ObjectType.House1; obj++) {
            res.push(this.object(jd, obj));
        }
        return res;
    };
    AstroCalculator.prototype.natal = function (jd, lat, lon, cosmogram, hSys) {
        return {
            houses: cosmogram ? [] : this.houses(jd, hSys, lat, lon),
            objects: this.objects(jd)
        };
    };
    AstroCalculator.prototype.solarJulDay = function (sunLon, jd) {
        var initJd = jd;
        var counter = 1000;
        while (counter--) {
            var lon = this.object(jd, defs_1.ObjectType.Sun).lon;
            if (Math.abs(lon - sunLon) < 1e-7) {
                return jd;
            }
            jd -= (lon + (lon < sunLon ? 360 : 0) - sunLon) / 2;
        }
        return 0;
    };
    return AstroCalculator;
}());
exports.AstroCalculator = AstroCalculator;
